const isRequired = (value: string | number | null | undefined): string | null => (
  (value === null || value === undefined || value === '')
    ? 'Required.'
    : null
);

export default isRequired;
